import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Section, SectionSlot, SupportedLocale } from '@youshift/shared/types';
import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';

import { CompactSectionSlotChip } from '../../../../components/Calendars/SectionSlotChip';

interface SortableOrphanSlotProps {
  id: number;
  sectionSlot: SectionSlot;
  section: Section;
  locale: SupportedLocale;
  showDay?: boolean;
}

export function SortableOrphanSlot({
  id,
  sectionSlot,
  section,
  locale,
  showDay,
}: SortableOrphanSlotProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
      data: {
        type: 'section_slot',
        id,
      },
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="group relative hover:scale-105 transition-transform duration-200 cursor-grab active:cursor-grabbing"
      {...attributes}
      {...listeners}
    >
      <div className="absolute -left-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        <ArrowsUpDownIcon className="w-4 h-4 text-gray-400" />
      </div>
      <CompactSectionSlotChip
        sectionSlot={sectionSlot}
        section={section}
        showDay={showDay}
        locale={locale}
      />
    </div>
  );
}
